import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import CollapseIcon from '../SvgIcons/CollapseIcon';
import ExpandIcon from '../SvgIcons/ExpandIcon';

const ExpandCollapseIconButton = ({ onClick, expandTitle, collapseTitle, collapsed, ...props }) => {
  const handleOnClick = () => {
    onClick(!collapsed);
  };

  return (
    <IconButton {...props} title={collapsed ? expandTitle : collapseTitle} onClick={handleOnClick}>
      {collapsed ? <ExpandIcon /> : <CollapseIcon />}
    </IconButton>
  );
};

ExpandCollapseIconButton.propTypes = {
  onClick: PropTypes.func,
  expandTitle: PropTypes.string,
  collapseTitle: PropTypes.string,
  collapsed: PropTypes.bool
};

ExpandCollapseIconButton.defaultProps = {
  onClick: () => {},
  expandTitle: 'Expand',
  collapseTitle: 'Collapse',
  collapsed: true
};

export default ExpandCollapseIconButton;
